import { useContext } from 'react';
import { useObservableState } from 'observable-hooks';
import facade from 'context/ApplicationContext/facade';
import { ApplicationContext } from 'context/index';
import { type ExtractObservableValueType, type FacadeReturnTypes, getObservableProp, type NullablePartial } from 'utils/modules/state';

interface UserContextFacade extends FacadeReturnTypes<typeof facade> {
   isLoading: boolean;
   error: any;
   context: ExtractObservableValueType<typeof facade.context$>;
}

const defaults: NullablePartial<UserContextFacade> = {
   isLoading: true,
};

export default function useApplicationContext() {
   const underlyingContext = useContext(ApplicationContext);

   const state = new Proxy<UserContextFacade>({} as UserContextFacade, {
      get: (target, prop: keyof UserContextFacade) => {
         if (prop === 'error') {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            return useObservableState(facade.query.selectError());
         }
         if (prop === 'isLoading') {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            return useObservableState(facade.loading$, defaults[prop]);
         }
         if (prop === 'context') {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            return useObservableState(underlyingContext);
         }

         return getObservableProp(facade, defaults, prop);
      },
   });

   return {
      state,
      api: facade.api,
   };
}
